(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-carousel"] && !Shopify.designMode) return;
  try {
    

class CustomerReviewsCarousel extends HTMLElement {

  connectedCallback() {

    this.track =
      this.querySelector('.crc-track');

    this.cards =
      Array.from(
        this.querySelectorAll(
          '[data-crc-card]'
        )
      );

    this.prevButton =
      this.querySelector(
        '[data-crc-prev]'
      );

    this.nextButton =
      this.querySelector(
        '[data-crc-next]'
      );

    this.dots =
      Array.from(
        this.querySelectorAll(
          '[data-crc-dot]'
        )
      );


    if (
      !this.track ||
      this.cards.length === 0
    ) {
      return;
    }


    this.onScroll =
      this.debounce(
        () => this.updateUi(),
        80
      );


    this.onResize =
      this.debounce(
        () => this.updateUi(),
        120
      );


    this.track.addEventListener(
      'scroll',
      this.onScroll,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      this.onResize,
      {
        passive: true
      }
    );


    if (this.prevButton) {

      this.prevButton
        .addEventListener(
          'click',
          () => {
            this.goToIndex(
              this.getCurrentIndex() - 1
            );
          }
        );

    }


    if (this.nextButton) {

      this.nextButton
        .addEventListener(
          'click',
          () => {
            this.goToIndex(
              this.getCurrentIndex() + 1
            );
          }
        );

    }


    this.dots.forEach(
      (dot) => {

        dot.addEventListener(
          'click',
          () => {

            this.goToIndex(
              Number(
                dot.dataset.crcDot
              )
            );

          }
        );

      }
    );


    this.addEventListener(
      'mouseenter',
      () => this.stopAutoplay()
    );


    this.addEventListener(
      'mouseleave',
      () => this.startAutoplay()
    );


    this.addEventListener(
      'focusin',
      () => this.stopAutoplay()
    );


    this.addEventListener(
      'focusout',
      () => this.startAutoplay()
    );


    this.updateUi();

    this.startAutoplay();

  }


  disconnectedCallback() {

    this.stopAutoplay();


    if (
      this.track &&
      this.onScroll
    ) {

      this.track.removeEventListener(
        'scroll',
        this.onScroll
      );

    }


    if (this.onResize) {

      window.removeEventListener(
        'resize',
        this.onResize
      );

    }

  }


  getStep() {

    const card =
      this.cards[0];


    if (!card) {
      return this.track.clientWidth;
    }


    const styles =
      getComputedStyle(
        this.track
      );


    const gap =
      parseFloat(
        styles.columnGap ||
        styles.gap ||
        0
      );


    return (
      card
        .getBoundingClientRect()
        .width
      +
      gap
    );

  }


  getCurrentIndex() {

    const step =
      this.getStep();


    if (!step) {
      return 0;
    }


    return Math.max(
      0,
      Math.min(
        this.cards.length - 1,
        Math.round(
          this.track.scrollLeft / step
        )
      )
    );

  }


  goToIndex(index) {

    const targetIndex =
      Math.max(
        0,
        Math.min(
          this.cards.length - 1,
          index
        )
      );


    const card =
      this.cards[targetIndex];


    if (!card) {
      return;
    }


    const targetLeft =
      card
        .getBoundingClientRect()
        .left
      -
      this.track
        .getBoundingClientRect()
        .left
      +
      this.track.scrollLeft;


    this.track.scrollTo({

      left: targetLeft,

      behavior:
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth'

    });

  }


  updateUi() {

    const currentIndex =
      this.getCurrentIndex();


    const maxScroll =
      Math.max(
        0,
        this.track.scrollWidth
        -
        this.track.clientWidth
        -
        2
      );


    const step =
      this.getStep();


    const maxIndex =
      step
        ? Math.ceil(
            maxScroll / step
          )
        : 0;


    if (this.prevButton) {

      this.prevButton.disabled =
        this.track.scrollLeft <= 2;

    }


    if (this.nextButton) {

      this.nextButton.disabled =
        this.track.scrollLeft
        >=
        maxScroll;

    }


    this.dots.forEach(
      (dot, index) => {

        const available =
          index <= maxIndex;


        const active =
          available
          &&
          index === currentIndex;


        dot.hidden =
          !available;


        dot.classList.toggle(
          'is-active',
          active
        );


        if (active) {

          dot.setAttribute(
            'aria-current',
            'true'
          );

        } else {

          dot.removeAttribute(
            'aria-current'
          );

        }

      }
    );

  }


  startAutoplay() {

    this.stopAutoplay();


    if (
      this.dataset.autoplay !== 'true'
      ||
      this.cards.length < 2
    ) {
      return;
    }


    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      return;
    }


    const interval =
      Math.max(
        3000,
        Number(
          this.dataset.interval
        )
        ||
        5000
      );


    this.autoplayTimer =
      window.setInterval(
        () => {

          const maxScroll =
            Math.max(
              0,
              this.track.scrollWidth
              -
              this.track.clientWidth
              -
              2
            );


          if (
            this.track.scrollLeft
            >=
            maxScroll
          ) {

            this.goToIndex(0);

          } else {

            this.goToIndex(
              this.getCurrentIndex()
              +
              1
            );

          }

        },
        interval
      );

  }


  stopAutoplay() {

    if (
      this.autoplayTimer
    ) {

      window.clearInterval(
        this.autoplayTimer
      );


      this.autoplayTimer =
        null;

    }

  }


  debounce(
    callback,
    delay
  ) {

    let timer;


    return (...args) => {

      window.clearTimeout(
        timer
      );


      timer =
        window.setTimeout(
          () =>
            callback(...args),
          delay
        );

    };

  }

}


if (
  !customElements.get(
    'customer-reviews-carousel'
  )
) {

  customElements.define(
    'customer-reviews-carousel',
    CustomerReviewsCarousel
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
